<div class="mr-3">
    @switch (type) {
        @case ("image") {
            <div>
                <img [src]="url" />
            </div>
        }
        @case ("icon") {
            <div class="icon color-bg-secondary color-text-inverse d-flex align-items-center justify-content-center">
                <kui-icon [name]="icon" size="lg"></kui-icon>
            </div>
        }
        @default {
            <div>
                <ng-content></ng-content>
            </div>
        }
    }
</div>
